export const getIndexFromLineCol = (text: string, line: number, col: number): number => {
  const parts = text.split('\n')
  let idx = 0
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < Math.max(0, line - 1) && i < parts.length; i++) {
    idx += parts[i].length + 1
  }
  idx += Math.max(0, col - 1)

  return Math.min(idx, text.length)
}
